export const TAG_FILTER_CONTROLLER_ID = 'TagFilteredContent';
export const CARD_SLIDER_CONTROLLER_ID = 'CardSlider';
export const COMPANY_FILTER_CONTROLLER_ID = 'CompanyFilter';
export const EVENT_REGISTRATION_CONTROLLER_ID = 'EventRegistration';
export const INTRO_CONTROLLER_ID = 'Intro';
